import { useActionless } from 'app-redux/hooks'
import { TOGGLE_MODAL } from 'app-redux/active/actions/types'

import Icon from 'components/elements/Icon'

import styles from './tagModal.module.scss'

type Props = {
  onClose: () => void
}

const TagModal = ({ onClose }: Props) => {
  const [toggleModal] = useActionless(TOGGLE_MODAL)

  return (
    <div className={`${styles.menuContainer}`}>
      <div className={styles.info}>
        <h4>Consider setting deck tags</h4>
      </div>
      <div className={styles.controls}>
        <button className={styles.button} onClick={() => toggleModal({ modalName: 'deckTags', flag: true })}>
          <Icon name="tags" /> <span>Tags</span>
        </button>

        <button className={styles.button} onClick={onClose}>
          <Icon name="close" /> <span>Close</span>
        </button>
      </div>
    </div>
  )
}

export default TagModal
